export const getJwt = () => {
  const envJwt = process.env.VUE_APP_JWT;
  return envJwt || (window as any).jwtPassed;
};
